import { ApiServiceStatus, ServiceType, ServiceTypeStr } from '@common/enums';
import { OdataServiceStatistics } from '@common/models';
import { getServiceUiInfo } from '@common/utils';

export class ServiceStatistics {
  api: ApiServiceInfo;
  available: boolean;
  count: number;
  i18nKey: string;
  enabled: boolean;
  iconCssClass: string;
  lastBackupDate: Date;
  servicePageUrl: (id: string) => string;
  serviceType: ServiceType;
  size: number;
  users: number;

  constructor(odataObj: OdataServiceStatistics) {
    this.serviceType = ServiceType[odataObj.Service] as ServiceType;
    const serviceUiInfo = getServiceUiInfo(this.serviceType);

    this.api = {
      status: odataObj.Api.Status,
      url: odataObj.Api.InstallUrl
    };
    this.available = odataObj.Available;
    this.count = odataObj.Count;
    this.i18nKey = serviceUiInfo.i18nKey;
    this.enabled = odataObj.Enabled;
    this.iconCssClass = serviceUiInfo.iconCssClass;
    this.lastBackupDate = odataObj.LastBackupDate ? new Date(odataObj.LastBackupDate) : null;
    this.servicePageUrl = serviceUiInfo.url;
    this.size = odataObj.Size;
    this.users = odataObj.ProtectedUsers;
  }
}

export interface ServiceStatisticsSaveObject {
  services: ServiceStatistics[];
  forAllEnabledUsers?: boolean;
}

interface ApiServiceInfo {
  status: ApiServiceStatus;
  url: string;
}

export interface ConfigureServices {
  Service: ServiceTypeStr;
  Enabled: boolean;
}
